<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="送货日期：">
            <el-date-picker v-model="searchForm.date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
              placeholder="选择日期" :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="分组：">
            <el-select v-model="searchForm.groupID" style="width:80%" :clearable="true">
              <el-option v-for="item in groupList" :key="item.ID" :label="item.GROUP_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button v-preventReClick @click="this.queryTable" style="float:right"
              :loading="loadSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-button v-preventReClick @click="exportFunctionExcel">带函数导出</el-button>
        <el-button v-preventReClick @click="exportExcel">导出</el-button>
        <el-button v-preventReClick @click="exportPriceExcel">带价格导出</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="14">
        <span>{{ this.name }}</span>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px">
      <el-col :data="tableData" v-for="item in tableData" :key="item.INCOME_DATE">
        <table cellpadding="0" cellspacing="0" style="width:100%" class="sending">
          <caption class="table-title" style="">{{ item.CNAME }}</caption>
          <tr style="width:100%">
            <td style="width:100%">
              <table cellpadding="0" cellspacing="0" style="width:100%">
                <tr class="table-line">
                  <td class="product-title" style="width:40%">品名</td>
                  <td class="product-title" style="width:100px;text-align:center">单位</td>
                  <td class="product-title" style="width:40%;text-align:center">数量</td>
                  <td class="product-title" style="width:100px;text-align:center">总计</td>
                </tr>
                <tr class="table-line">
                  <td class="product-title" style="width:40%">品名</td>
                  <td class="product-title" style="width:100px;text-align:center">单位</td>
                  <td class="product-title" style="width:40%;text-align:center">数量</td>
                  <td class="product-title" style="width:100px;text-align:center;border:0">总计</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr class="table-line" v-for="index in item.DATA" :key="index.INCOME_DATE">
            <td class="product" style="width:40%;">{{ index.N }}</td>
            <td class="product" style="width:100px;text-align:center">{{ index.U }}</td>
            <td class="product" style="width:40%;text-align:center">{{ index.D }}</td>
            <td class="product" style="width:100px;text-align:center">{{ index.T }}</td>
          </tr>
        </table>
      </el-col>
    </el-row>
  </div>
</template>
<script>

import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data () {
    return {
      searchForm: {
        date: date(new Date(), '%F'),
      },
      tableData: [],
      loadSearch: false,
      // loadExport: false,
      name: '',
      groupList: [],
    };
  },
  methods: {

    queryGroup () {
      const params = {
        SERVICE_ID: '10081',
        OTYPE: 4,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: 0,
      };
      http.post(params).then((result) => {
        this.groupList = result[0].OP_ROLE;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    queryTable () {
      const params = {
        SERVICE_ID: '10069',
        OTYPE: 1,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: date(this.searchForm.date, '%F'),
      };
      if (this.searchForm.groupID) {
        params.PICK_GROUP_ID = this.searchForm.groupID;
      }
      this.loadSearch = true;
      http.post(params).then((result) => {
        if (result[0].FLAG === 0) {
          if (result[0].DATA) {
            this.loadSearch = false;
            this.tableData = result[0].DATA;
            this.name = result[0].COMPANY_NAME;
          } else {
            this.loadSearch = false;
            this.$message.show({
              text: '暂无数据',
              type: 'error',
            });
          }
        } else {
          this.loadSearch = false;
          this.$confirm('您选择日期的订单中存在未分类的产品，请先进行分类?', '提示', {
            confirmButtonText: '立即前往',
            type: 'warning',
            showClose: false,
            showCancelButton: false,
          }).then(() => {
            this.$router.push({ name: 'PurchaseMatchProduct' });
            sessionStorage.setItem('sendDay', date(this.searchForm.date, '%F'));
          });
        }
      }).catch((error) => {
        this.loadSearch = false;
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 带函数导出
    exportFunctionExcel () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10069',
            OTYPE: 2,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            SEND_DAY: date(this.searchForm.date, '%F'),
            FORMULA_FLAG: 1,
          };
          if (this.searchForm.groupID) {
            params.PICK_GROUP_ID = this.searchForm.groupID;
          }
          // this.loadExport = true
          http.post(params).then((result) => {
            // this.loadExport = false
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            // this.loadExport = false
            this.$message.show({
              text: error,
              type: 'error',
            });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    exportExcel () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10069',
            OTYPE: 2,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            SEND_DAY: date(this.searchForm.date, '%F'),
          };
          if (this.searchForm.groupID) {
            params.PICK_GROUP_ID = this.searchForm.groupID;
          }
          // this.loadExport = true
          http.post(params).then((result) => {
            // this.loadExport = false
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);

            document.body.style.cursor = 'default';
          }).catch((error) => {
            // this.loadExport = false
            this.$message.show({
              text: error,
              type: 'error',
            });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    exportPriceExcel () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10069',
            OTYPE: 3,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            SEND_DAY: date(this.searchForm.date, '%F'),
          };
          if (this.searchForm.groupID) {
            params.PICK_GROUP_ID = this.searchForm.groupID;
          }
          // this.loadExport = true
          http.post(params).then((result) => {
            // this.loadExport = false
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            // this.loadExport = false
            this.$message.show({
              text: error,
              type: 'error',
            });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
  },
  created () {
    // 这里用来在系统设置中设置页面展示条目，文件在systemSetting的unitManage中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryGroup();
  },
};
</script>
<style scoped>
.product {
  color: #606266;
  padding-left: 5px;
  height: 40px
}

.table-title {
  height: 50px;
  line-height: 50px;
  border: 1px solid #ebeef5;
  color: #909399;
  font-weight: bold;
  border-bottom: 0;
}

.table-line {
  float: left;
  width: 50%;
}

.sending,
.sending tr th,
.sending tr td {
  border: 1px solid #ebeef5;
}

.product-title {
  border-top: 0 !important;
  border-bottom: 0 !important;
  color: #606266;
  padding-left: 5px;
  height: 40px
}
</style>



// WEBPACK FOOTER //
// src/components/sendDocument/shoppingDocument.vue